import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';

function LoadingSpinner({ size = 40 }) {
  return (
    <div style={{ display:'flex', justifyContent:'center', alignItems:'center' }}>
      <CircularProgress size={size} sx={{ color:'#6c757d' }} />
    </div>
  );
}

export default LoadingSpinner; 